/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    CashRegisterModelsListDto,
    CashRegistersModelsListFilterParams,
} from '../api/cashRegisters/cashRegistersClient.typings';
import { PageQueryParams, SortQueryParams } from '../api/apiCommon.typings';
import { createAction } from '../../utils/redux-utils';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum CashRegistersActionType {
    OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE = 'RegistryCashRegistersList/ open page',
    EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE = 'RegistryCashRegistersList/ exit page',

    APPLY_PAGING = 'RegistryCashRegistersList/ apply paging',
    APPLY_FILTERS = 'RegistryCashRegistersList/ apply filters',
    APPLY_SORTING = 'RegistryCashRegistersList/ apply sorting',

    CHANGE_FILTERS = 'RegistryCashRegistersList/ change filters',

    DOWNLOAD_EXCEL = 'RegistryCashRegistersList/ download cash registers list as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryCashRegistersList/ download cash registers list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryCashRegistersList/ download cash registers list as excel error',

    FETCH_CASH_REGISTERS_LIST_SUCCESS = 'RegistryCashRegistersList/ fetch cash registers list success',
    FETCH_CASH_REGISTERS_LIST_ERROR = 'RegistryCashRegistersList/ fetch cash registers list error',
}

export const openRegistryCashRegistersListAction = () =>
    createAction(CashRegistersActionType.OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE);

export const exitRegistryCashRegistersListAction = () =>
    createAction(CashRegistersActionType.EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE);

export const applyPagingAction = (params: PageQueryParams) =>
    createAction(CashRegistersActionType.APPLY_PAGING, params);

export const applyFilteringAction = () => createAction(CashRegistersActionType.APPLY_FILTERS);

export const applySortingAction = (params: SortQueryParams) =>
    createAction(CashRegistersActionType.APPLY_SORTING, params);

export const changeFiltersAction = (params: CashRegistersModelsListFilterParams) =>
    createAction(CashRegistersActionType.CHANGE_FILTERS, params);

export const downloadCashRegistersListAsExcelAction = () => createAction(CashRegistersActionType.DOWNLOAD_EXCEL);

export const downloadCashRegistersListAsExcelSuccessAction = () =>
    createAction(CashRegistersActionType.DOWNLOAD_EXCEL_SUCCESS);

export const downloadCashRegistersListAsExcelErrorAction = (notification: Notification) =>
    createAction(CashRegistersActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchCashRegistersListSuccessAction = (list: CashRegisterModelsListDto) =>
    createAction(CashRegistersActionType.FETCH_CASH_REGISTERS_LIST_SUCCESS, {
        list,
        notification:
            list.count === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchCashRegistersListErrorAction = (notification: Notification) =>
    createAction(CashRegistersActionType.FETCH_CASH_REGISTERS_LIST_ERROR, { notification });

export type CashRegistersAction =
    | ReturnType<typeof openRegistryCashRegistersListAction>
    | ReturnType<typeof exitRegistryCashRegistersListAction>
    | ReturnType<typeof applyPagingAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof applySortingAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof downloadCashRegistersListAsExcelAction>
    | ReturnType<typeof downloadCashRegistersListAsExcelSuccessAction>
    | ReturnType<typeof downloadCashRegistersListAsExcelErrorAction>
    | ReturnType<typeof fetchCashRegistersListSuccessAction>
    | ReturnType<typeof fetchCashRegistersListErrorAction>;
